/**
 * Integration with Discourse to display the latest posts in the home page.
 */
(() => {
  const baseUrl = "https://community.siemens.com";

  /**
   * Fetches Community posts from the Developer Space category (14).
   *
   * @return {Promise<Array>} An array of posts with an excerpt.
   */
  async function getPosts() {
    const response = await fetch(`${baseUrl}/c/developerspace/14.json`);
    const data = await response.json();
    return data.topic_list.topics;
  }

  /**
   * Converts a date-time string to a formatted string in the format "Mmm. dd".
   *
   * @param {string} dateString - The date-time string to format. Supports both "YYYY-MM-DD HH:mm:ss" and ISO string formats.
   * @return {string} A formatted date string in the format "Mmm. dd".
   */
  function formatDate(dateString) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(dateString);
    const month = months[date.getMonth()];
    const day = date.getDate();

    return `${month}. ${day.toString().padStart(2, "0")}`;
  }

  /**
   * Truncate title when it exceeds a certain number of characters.
   * @param {string} str - The title string to truncate.
   * @param {number} n - The maximum number of characters allowed before truncation.
   * @return {string} - The truncated or original title string.
   */
  function truncateString(str, n) {
    if (str.length > n) {
      return str.slice(0, n) + `…`;
    } else {
      return str;
    }
  }

  getPosts().then((posts) => {
    const cards = document.querySelectorAll(".discourse-latest-posts .latest-post");
    let postIndex = 0;
    cards.forEach((card) => {
      if (posts[postIndex]) {
        const anchor = document.createElement("a");
        const maxTitleLength = 60;
        anchor.href = baseUrl + "/t/" + posts[postIndex].slug + "/" + posts[postIndex].id;
        anchor.textContent = truncateString(posts[postIndex].fancy_title ?? posts[postIndex].title, maxTitleLength);

        const postContent = card.querySelector(".post-content");
        card.querySelector("h4").appendChild(anchor);
        const postParagraph = document.createElement("p");
        if (posts[postIndex].excerpt) {
          const maxChars = 160;
          let text = posts[postIndex].excerpt;
          if (text.length > maxChars) {
            const lastPeriodIndex = text.substring(0, maxChars).lastIndexOf(". ");
            if (lastPeriodIndex !== -1) {
              text = text.substring(0, lastPeriodIndex + 1);
            }
          }
          postParagraph.innerHTML = text;
        }
        postContent.appendChild(postParagraph);

        const footer = document.createElement("footer");
        const commentsElem = document.createElement("div");
        commentsElem.classList.add("comments");
        commentsElem.innerText = posts[postIndex].reply_count;
        const dateElem = document.createElement("div");
        dateElem.classList.add("date");
        dateElem.innerText = formatDate(posts[postIndex].created_at);
        const viewsElem = document.createElement("div");
        viewsElem.classList.add("views");
        viewsElem.innerText = posts[postIndex].views;

        footer.appendChild(commentsElem);
        footer.appendChild(viewsElem);
        footer.appendChild(dateElem);
        card.appendChild(footer);

        postIndex++;
      }
    });

    adjustRowHeights();

    // Listen for window resize events and adjust the heights. We only need to attach this once.
    window.addEventListener("resize", adjustRowHeights);
  });

  /**
   * Adjust Blog/Discourse post height by row.
   */
  function adjustRowHeights() {
    const blogPosts = document.querySelectorAll(".blog-latest-posts .latest-post");
    const discoursePosts = document.querySelectorAll(".discourse-latest-posts .latest-post");

    // There is the same number of posts (2) in both containers.
    for (let i = 0; i < blogPosts.length; i++) {
      // Reset heights to auto to get natural height.
      blogPosts[i].style.height = "auto";
      discoursePosts[i].style.height = "auto";

      const maxHeight = Math.max(blogPosts[i].offsetHeight, discoursePosts[i].offsetHeight);

      // Set both posts in the row to the same height.
      blogPosts[i].style.height = maxHeight + "px";
      discoursePosts[i].style.height = maxHeight + "px";
    }
  }
})();
